import { Link, Outlet, useLocation } from "react-router-dom";
import { Phone, LifeBuoy, MessageSquare } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ChatWidget } from "@/components/ChatWidget";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { MemberWelcomeBar } from "@/components/MemberWelcomeBar";
import { InstallPrompt } from "@/components/InstallPrompt";

export const SMS_HREF = "sms:+13104220669?&body=" + encodeURIComponent("Hi David, I need help with…");

export default function Layout() {
  const [open, setOpen] = useState(false);
  const [logo, setLogo] = useState(null);
  const [flyer, setFlyer] = useState(null);
  const [flyerDownload, setFlyerDownload] = useState(null);
  const location = useLocation();
  useEffect(() => { setOpen(false); }, [location.pathname]);
  useEffect(() => {
    api.get("/branding")
      .then((r) => {
        setLogo(r.data.logo_url ? `${process.env.REACT_APP_BACKEND_URL}${r.data.logo_url}` : null);
        setFlyer(r.data.flyer_url ? `${process.env.REACT_APP_BACKEND_URL}${r.data.flyer_url}` : null);
        setFlyerDownload(r.data.flyer_download_url ? `${process.env.REACT_APP_BACKEND_URL}${r.data.flyer_download_url}` : null);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[#0B1120] text-slate-100">
      <SiteHeader logo={logo} open={open} onToggle={() => setOpen((v) => !v)} />
      <MemberWelcomeBar />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter logo={logo} flyer={flyer} flyerDownload={flyerDownload || flyer} />
      <ChatWidget />
      <div className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-slate-900/95 backdrop-blur-md border-t border-slate-800 p-2 grid grid-cols-3 gap-2" data-testid="sticky-mobile-bar">
        <a href="tel:+13104220669" className="dg-btn-ghost rounded-lg py-3 text-sm flex items-center justify-center gap-2" data-testid="sticky-call-btn">
          <Phone className="w-4 h-4" /> Call
        </a>
        <a href={SMS_HREF} className="dg-btn-ghost rounded-lg py-3 text-sm flex items-center justify-center gap-2" data-testid="sticky-text-btn">
          <MessageSquare className="w-4 h-4" /> Text
        </a>
        <Link to="/ask" className="dg-btn-primary rounded-lg py-3 text-sm flex items-center justify-center gap-2" data-testid="sticky-ask-btn">
          <LifeBuoy className="w-4 h-4" /> Ask
        </Link>
      </div>
      <InstallPrompt />
    </div>
  );
}
